import { Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useClient } from "../Provider";
import BoxInfo from "./BoxInfo";
import TableInfo from "./TableInfo";

function InfoClient() {
  let params = useParams();
  const id = params.id;
  const {
    state: { selected: client },
    fetchOne: fetchClient,
  } = useClient();

  useEffect(() => {
    fetchClient(id);
  }, [id]);
  if (!client) return;
  return (
    <>
      <Typography variant="Poster" component="h4">
        Client Details
      </Typography>
      <BoxInfo client={client} />
      <TableInfo client={client} />
    </>
  );
}

export default InfoClient;